import { apolloQueryWrapper } from '@/shared/api';
import MCT_DAILY_SUMMARIES_QUERY from '@/entities/heart-rate/api/queries/mctDailySummaries';

// TODO(ts): `holterProfile` is queried as an opaque scalar (no sub-selection in the
// GraphQL document), so its `mctDailySummaries` shape isn't derivable from this query.
export type MctDailySummariesQueryResult = {
  newReportData: {
    isSuccess: boolean;
    message: string;
    reportData: {
      holterProfile: any;
    };
  };
};

// TODO(ts): typed as the NewReportDataInput GraphQL input once its server-side shape is documented
/**
 * Fetches the MCT daily summaries of a holter profile. Runs the daily-summaries GraphQL query through the shared Apollo wrapper with the given caching and cancellation settings, then unwraps the nested report-data payload.
 *
 * @param input - Query input identifying the study and profile.
 * @param key - Cancellation key the request is registered under.
 * @param isUsingCache - Whether the Apollo cache may satisfy the query.
 * @param needCancel - Whether an in-flight request under the same key is cancelled.
 * @returns A promise resolving to the profile's MCT daily summaries.
 */
const fetchMctDailySummaries = async (
  input: any,
  key?: string | null,
  isUsingCache = false,
  needCancel = true,
) => {
  const result = await apolloQueryWrapper<MctDailySummariesQueryResult>({
    options: {
      query: MCT_DAILY_SUMMARIES_QUERY,
      variables: { input },
    },
    isUsingCache,
    key,
    needCancel,
  });
  const { data } = result;
  const { mctDailySummaries } = data?.newReportData?.reportData?.holterProfile || {};
  return mctDailySummaries;
};

export default fetchMctDailySummaries;
